import script from "./CTournamentsSelection.vue?vue&type=script&setup=true&lang=ts"
export * from "./CTournamentsSelection.vue?vue&type=script&setup=true&lang=ts"

import "./CTournamentsSelection.vue?vue&type=style&index=0&id=3ce42f14&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ce42f14"]])

export default __exports__